import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-095902e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addsku" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "温馨提示：商品链接或者海关编码用于品名归类，出口报关及进口清关，请您至少填写其中一项。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "商品编码(SKU编码)",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.skuCode), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.modelRef.skuCode,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelRef.skuCode) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "商品属性",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.hasBattery), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                      value: _ctx.modelRef.hasBattery,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelRef.hasBattery) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("普货")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer", "value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { gutter: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "商品申报中文品名",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.declareNameCn), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.modelRef.declareNameCn,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modelRef.declareNameCn) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "商品申报英文品名",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.declareNameEn), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.modelRef.declareNameEn,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelRef.declareNameEn) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { gutter: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "商品申报价值",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.declareValue), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.modelRef.declareValue,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelRef.declareValue) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "申报币种",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.declareOriginalCurrency), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                      value: _ctx.modelRef.declareOriginalCurrency,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modelRef.declareOriginalCurrency) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "CNY" }, {
                          default: _withCtx(() => [
                            _createTextVNode("CNY")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "USD" }, {
                          default: _withCtx(() => [
                            _createTextVNode("USD")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "EUR" }, {
                          default: _withCtx(() => [
                            _createTextVNode("EUR")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer", "value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { gutter: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "声明重量",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.declareWeight), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      type: "number",
                      oninput: "value=value.replace(/[^\\d]/g,'')",
                      value: _ctx.modelRef.declareWeight,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelRef.declareWeight) = $event)),
                      suffix: "g"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { gutter: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "声明长度",
                  labelCol: {span: 12},
                  wrapperCol: {span: 12}
                }, _ctx.validateInfos.length), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      type: "number",
                      oninput: "value=value.replace(/[^\\d]/g,'')",
                      value: _ctx.modelRef.length,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelRef.length) = $event)),
                      suffix: "cm"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "声明宽度",
                  labelCol: {span: 12},
                  wrapperCol: {span: 12}
                }, _ctx.validateInfos.width), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      type: "number",
                      oninput: "value=value.replace(/[^\\d]/g,'')",
                      value: _ctx.modelRef.width,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modelRef.width) = $event)),
                      suffix: "cm"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "声明高度",
                  labelCol: {span: 10},
                  wrapperCol: {span: 11}
                }, _ctx.validateInfos.height), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      type: "number",
                      oninput: "value=value.replace(/[^\\d]/g,'')",
                      value: _ctx.modelRef.height,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelRef.height) = $event)),
                      suffix: "cm"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "商品链接",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.declareUrl), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.modelRef.declareUrl,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelRef.declareUrl) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "商品海关编码",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.hsCode), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.modelRef.hsCode,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modelRef.hsCode) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_2,
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "商品品牌类别",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.productBrand), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      getPopupContainer: (triggerNode)=>triggerNode.parentNode,
                      value: _ctx.modelRef.productBrand,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modelRef.productBrand) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "自有品牌" }, {
                          default: _withCtx(() => [
                            _createTextVNode("自有品牌")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "无品牌" }, {
                          default: _withCtx(() => [
                            _createTextVNode("无品牌")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["getPopupContainer", "value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { gutter: 16 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "申报商品材质",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.material), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.modelRef.material,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modelRef.material) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "申报商品用途",
                  labelCol: {span: 8},
                  wrapperCol: {span: 14}
                }, _ctx.validateInfos.purpose), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.modelRef.purpose,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modelRef.purpose) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: "备注",
                  labelCol: {span: 4},
                  wrapperCol: {span: 19}
                }, _ctx.validateInfos.remarks), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_textarea, {
                      value: _ctx.modelRef.remarks,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modelRef.remarks) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { style: {"display":"flex","justify-content":"center","align-items":"center","margin-top":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.handleSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("确定")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, { onClick: _ctx.handleCtrl }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}